"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Modal = require("@insided/shared/uikit/Modal");

var _buttonControl = _interopRequireDefault(require("../../preact-components/button-control"));

var CancelInviteModal = function CancelInviteModal(_ref) {
  var isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      onCancelInvitation = _ref.onCancelInvitation;
  return (0, _preact.h)(_Modal.Modal, {
    isOpen: isOpen,
    size: "medium"
  }, (0, _preact.h)(_Modal.ModalHeader, {
    title: "Cancel invitation? ",
    onClose: onClose
  }), (0, _preact.h)(_Modal.ModalBody, null, "This will invalidate the link in the original invite email, and this person will not be able to register as a team member."), (0, _preact.h)(_Modal.ModalFooter, null, (0, _preact.h)(_buttonControl.default, {
    title: "Cancel invitation",
    variant: "danger",
    onClick: onCancelInvitation,
    class: "qa-cancel-invitation"
  }), (0, _preact.h)(_buttonControl.default, {
    title: "Cancel",
    onClick: function onClick() {
      return onClose();
    }
  })));
};

var _default = CancelInviteModal;
exports.default = _default;